import { render, staticRenderFns } from "./TabModalRate.vue?vue&type=template&id=248c53aa&"
import script from "./TabModalRate.vue?vue&type=script&lang=js&"
export * from "./TabModalRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports